






















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { AccountModule } from '@/store/modules/account';
import Logo from './logo.vue';
import GrabTodos from './grabTodos/index.vue';
import AccountAvatar from '@/components/avatar/accountAvatar.vue';
import { getAccount } from '@/utils/user';
import { aesDecrypt } from '@/utils/other';

@Component({
  components: {
    Logo,
    AccountAvatar,
    GrabTodos,
  },
})
export default class TopBar extends Vue {
  @Prop({required: true}) private globalRefreshLoading!: (isShow: boolean) => void;
  get accountName() {
    return AccountModule.name;
  }
  get userDetailInfo() {
    return AccountModule.userDetailInfo;
  }
  get language() {
    return this.userDetailInfo?.language || 0;
  }
  @Watch('language')
  private watchLanguage(language: 0 | 1) {
    this.updateLanguage(language === 0 ? 'zh' : 'en');
  }
  private logout() {
    AccountModule.Logout();
    location.replace('/');
  }
  private refresh() {
    const account = getAccount();
    if (account && account.mobile && account.pw) {
      this.globalRefreshLoading(true);
      AccountModule.Login({
        mobile: account.mobile,
        password: aesDecrypt(account.pw),
      })
      .then((res) => {
        this.globalRefreshLoading(false);
      })
      .catch((error) => {
        this.logout();
      });
    } else {
      this.logout();
    }
  }
  private showMenu() {
    AppModule.ToggleMenuDrawerVisible();
  }
  private updateLanguage(language: 'zh' | 'en') {
    AppModule.SetLanguage(language);
    this.$i18n.locale = language;
    document.documentElement.lang = language;
  }
}

